import {create} from 'zustand';
import {CEXType, WalletType} from "../types/types";
import {Chain} from "viem";
import {DEFAULT_WALLET_METHODS} from "../hooks/useConfig";

// export const useEVMModalStore = create<{
//     isOpen: boolean,
//     type: 'bind' | 'login' | ''
//     open: (type: 'bind' | 'login') => void,
//     close: () => void
// }>(set => ({
//     isOpen: false,
//     type: '',
//     open: (type: 'bind' | 'login') => set({isOpen: true, type}),
//     close: () => set({isOpen: false})
// }));

type WalletModalType = {
    isOpen: boolean,
    type: 'bind' | 'login' | ''
    open: (type: 'bind' | 'login') => void,
    close: () => void
}

export const useTRONModalStore = create<WalletModalType>(set => ({
    isOpen: false,
    type: '',
    open: (type: 'bind' | 'login') => set({isOpen: true, type}),
    close: () => set({isOpen: false})
}));

export const useTONModalStore = create<WalletModalType>(set => ({
    isOpen: false,
    type: '',
    open: (type: 'bind' | 'login') => set({isOpen: true, type}),
    close: () => set({isOpen: false})
}));

export const useBTCModalStore = create<WalletModalType>(set => ({
    isOpen: false,
    type: '',
    open: (type: 'bind' | 'login') => set({isOpen: true, type}),
    close: () => set({isOpen: false})
}));
export const useEVMModalStore = create<WalletModalType>(set => ({
    isOpen: false,
    type: '',
    open: (type: 'bind' | 'login') => set({isOpen: true, type}),
    close: () => set({isOpen: false})
}));

export const useCEXBindModalStore = create<{
    type: CEXType | ''
    isOpen: boolean,
    open: (type: CEXType) => void,
    close: () => void
}>(set => ({
    type: '',
    isOpen: false,
    open: (type: CEXType) => set({isOpen: true, type}),
    close: () => set({isOpen: false})
}));


export const useWalletModalStore = create<{
    isOpen: boolean,
    type: 'bind' | 'login' | ''
    methods?: WalletType[]
    open: (type: 'bind' | 'login', methods?: WalletType[]) => void,
    close: () => void
}>(set => ({
    isOpen: false,
    type: '',
    methods: [],
    open: (type: 'bind' | 'login', methods = DEFAULT_WALLET_METHODS) => set({isOpen: true, type, methods}),
    close: () => set({isOpen: false})
}))